import { ReactElement } from 'react';
import { Component as ShippingIcon } from 'icons/icon-circle-lime--shipping-box.svg';
import styles from './Banner.module.scss';

type Props = {
    amountAwayFromFreeShipping: string;
}

export function FreeShippingBanner({ amountAwayFromFreeShipping }: Props): ReactElement {
  return (
    <div className={`${styles.banner_container} ${styles.freeShippingBanner}`}>
      <ShippingIcon />
      <div>
        <span style={{ fontWeight: 'bold' }}>{`Add ${amountAwayFromFreeShipping} `}</span>
        to get free shipping!
      </div>
    </div>
  );
}
